import React, { useEffect, useState } from 'react';
import { Box, Grid, TextField, Container, InputLabel } from '@mui/material';
import styles from '../components/Managebranches.module.css';
import { ErrorType } from '../../../../../components/FormTextInput/types';
import { useNavigate } from 'react-router-dom';
import MapAutocomplete from '../../../../../components/googleMap/MapAutocomplete';
import NewFormTextInput from '../../../../../components/FormTextInput/NewFormTextInput';
import { reset } from '../service/Branchslice';
import CancelModal from '../../../../../components/CancelModal/CancelModal';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CountryCodePhoneInput from '../../../../../components/CountryCodePhoneInput/CountryCodePhoneInput';
import {
  getCountries,
  getCountryCallingCode,
  isValidPhoneNumber,
} from 'libphonenumber-js';
import { useAuthUser } from 'react-auth-kit';
import axios from 'axios';
import { GetInstituteByIdRequest } from '../../InstituteProfile/service/institute.request';
import BranchSkeleton from '../../../../../components/Skeletons/BranchSkeleton';
import { getUserById } from '../../UserDetails/service/userDetailsSlice';
import { useDispatch } from 'react-redux';
import { getInstituteById } from '../../InstituteProfile/service/instituteSlice';
import CurrencyDropDown from '../../../../../components/CurrencyDropDown/CurrencyDropDown';
import AutoCompleteField from '../../../../../components/AutoCompleteField/AutoCompleteField';
import { useCountries } from 'use-react-countries';
import SaveBtn from '../../../../../components/Buttons/SaveBtn';
import CancelBtn from '../../../../../components/Buttons/CancelBtn';
import {
  checkObjectsEqual,
  filterObjectKeys,
} from '../../../../../components/CommonFunctions/CommonFunctions';
import Previews from '../../InstituteProfile/DropZoneFile';
import galleryIcon from '../../../../../assets/images/image.png';
import { fileUpload } from '../../../Main/components/FileUpload/service/fileUploadSlice';
import { useSelector } from 'react-redux';

// Style
const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 490,
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: 24,
  borderRadius: '5px',
  p: 3,
};

// Component
export default function BranchEditor(props: any) {
  const {
    CreateBranch,
    add,
    GetBranchById,
    branchById,
    UpdateBranch,
    success,
    error,
    setIsActive,
    backBtn,
    branchByIdLoading,
    loading,
  } = props;
  const navigate = useNavigate();
  const auth = useAuthUser();
  const authUser = auth();
  const dispatch = useDispatch();
  const activeInstitute = JSON.parse(localStorage.getItem('ACTIVE_INSTITUTE')!);
  const { countries } = useCountries();

  const [branchDetails, setBranchDetails] = React.useState<any>({
    instituteId: '',
    branchName: '',
    buildingNumber: '',
    locality: '',
    pin: '',
    state: '',
    city: '',
    landmark: '',
    latitude: '',
    longitude: '',
    contactNumber: '',
    contactCountryCode: '91',
    email: '',
    isFirstBranch: true,
    status: 'ACTIVE',
    id: '',
    createdById: '',
    createdByName: '',
    updatedById: '',
    updatedByName: '',
    currency: '',
    country: '',
    branchImage: '',
  });

  const pinRegex = /^\d{6}$/;
  const [pinError, setPinError] = React.useState<boolean>(false);
  const [countryCode, setCountryCode] = React.useState<any>('in');

  const [formDisabled, setFormDisabled] = React.useState<boolean>(false);
  const [editVal, setEditVal] = useState<any>(null);

  const [showErrMsz, setShowErrMsz] = React.useState<boolean>(true);
  const [openModal, setOpenModal] = React.useState<boolean>(false);
  const [errorType, setErrorType] = React.useState<ErrorType>('client');
  const [validStateEmail, setValidStateEmail] = React.useState<boolean>(true);
  const [validStatePhone, setValidStatePhone] = React.useState<boolean>(true);
  const [validStateLocality, setValidStateLocality] =
    React.useState<boolean>(true);
  const [validStateBuildingNumber, setValidStateBuildingNumber] =
    React.useState<boolean>(true);
  const [validStateBranchName, setValidStateBranchName] =
    React.useState<boolean>(true);
  const [validStateCountry, setValidStateCountry] =
    React.useState<boolean>(true);

  const setValidateStatusEmail = React.useCallback((val: boolean) => {
    setValidStateEmail(val);
  }, []);

  const setValidateStatusLocality = React.useCallback((val: boolean) => {
    setValidStateLocality(val);
  }, []);
  const setValidateStatusBuildingNumber = React.useCallback((val: boolean) => {
    setValidStateBuildingNumber(val);
  }, []);
  const setValidateStatusBranchName = React.useCallback((val: boolean) => {
    setValidStateBranchName(val);
  }, []);
  const [
    validatingFirstTimeBranchCreation,
    setValidatingFirstTimeBranchCreation,
  ] = useState<any>();

  const getCountryByName = (countryName: string) => {
    return countries?.find(
      (country: any) =>
        country?.name?.toLowerCase() === countryName?.toLowerCase()
    );
  };

  //Shedule
  const handleGeoChange = React.useCallback(
    (geoLocation: any) => {
      let templocality: any,
        tempPin: any,
        tempCity: any,
        tempStat: any,
        tempCountry: any;

      geoLocation.address_components.map((ele: any) => {
        if (ele.types[0] === 'locality') {
          templocality = ele?.long_name;
        } else if (ele.types[0] === 'postal_code') {
          tempPin = ele?.long_name;
          fetchPincodeData(ele?.long_name);
        } else if (ele.types[0] === 'administrative_area_level_3') {
          tempCity = ele?.long_name;
        } else if (ele.types[0] === 'administrative_area_level_1') {
          tempStat = ele?.long_name;
        } else if (ele.types[0] === 'country') {
          tempCountry = ele?.long_name;
        }
      });
      setBranchDetails({
        ...branchDetails,
        latitude:
          geoLocation !== null ? `${geoLocation.geometry.location.lat()}` : '',
        longitude:
          geoLocation !== null ? `${geoLocation.geometry.location.lng()}` : '',
        locality: templocality,
        city: tempCity === templocality ? tempCity : templocality,
        state: tempStat,
        pin: tempPin,
        country: getCountryByName(tempCountry)?.name,
        currency: getCountryByName(tempCountry)?.currencies[0]?.symbol,
      });
      if (getCountryByName(tempCountry)?.name) {
        setValidStateCountry(true);
      }
      if (add) {
        const country = getCountryByName(tempCountry);
        if (country) {
          const callingCode = country?.countryCallingCode?.replace('+', '');
          const code = getCountryCodeFromCallingCode(callingCode);
          setCountryCode(code?.toLowerCase());
        }
      }
    },
    [branchDetails, add]
  );

  const getCountryCodeFromCallingCode = (
    callingCode: string
  ): string | null => {
    if (!callingCode) return null;

    const countryCode = getCountries().find(
      (code) => getCountryCallingCode(code) === callingCode
    );

    return countryCode || null;
  };
  // Pincode related

  const fetchPincodeData = async (pin: string) => {
    try {
      const response = await axios.get(
        `https://api.postalpincode.in/pincode/${pin}`
      );
      if (response.data && response.data.length > 0) {
        const pinData = response.data[0];

        const firstPostOffice = pinData?.PostOffice?.[0];
        if (firstPostOffice !== null || firstPostOffice !== undefined) {
          setBranchDetails((prevDetails: any) => ({
            ...prevDetails,
            city: firstPostOffice?.District,
            state: firstPostOffice?.State,
            locality: firstPostOffice?.Name,
            country: getCountryByName(firstPostOffice?.Country)?.name,
            currency: getCountryByName(firstPostOffice?.Country)
              ?.currencies?.[0]?.symbol,
          }));
          if (getCountryByName(firstPostOffice?.Country)?.name) {
            setValidStateCountry(true);
          }
          if (add) {
            const country = getCountryByName(firstPostOffice?.Country);
            if (country) {
              const callingCode = country?.countryCallingCode?.replace('+', '');
              const code = getCountryCodeFromCallingCode(callingCode);
              setCountryCode(code?.toLowerCase());
            }
          }
        } else {
          setBranchDetails((prevDetails: any) => ({
            ...prevDetails,
            city: '',
            state: '',
            locality: '',
            country: '',
            currency: '',
          }));
        }
      }
    } catch (error) {
      console.error('Error fetching pincode data:', error);
    }
  };
  const handlePinChange = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setBranchDetails((prevDetails: any) => ({
        ...prevDetails,
        pin: event.target.value.trimStart(),
      }));

      if (!pinRegex?.test(event.target.value)) {
        setPinError(true);
      } else {
        setPinError(false);
        const pin = event.target.value;

        if (pin?.length >= 6) {
          fetchPincodeData(pin);
        }
      }
    },
    [pinRegex]
  );

  // Handle change
  const handleChange = React.useCallback(
    (event: any) => {
      setShowErrMsz(true);
      if (errorType === 'server') {
        setValidStateEmail(true);
      }
      setErrorType('client');
      const { id, value } = event.target;
      const lowercaseValue =
        id === 'email' ? value.toLowerCase().trimStart() : value.trimStart();

      setBranchDetails({
        ...branchDetails,
        [id]: lowercaseValue,
      });
    },
    [branchDetails, errorType]
  );

  const selectedCountry = countries
    ? countries?.find(
        (item: any) =>
          item.name?.toLowerCase() === branchDetails.country?.toLowerCase()
      )
    : '';
  const onCountryChange = React.useCallback(
    (event: object, value: any | null) => {
      if (value !== null) {
        setBranchDetails({
          ...branchDetails,
          country: value?.name,
          currency: value?.currencies?.[0]?.symbol,
        });
        setValidStateCountry(true);
        if (add) {
          const country = getCountryByName(value?.name);
          if (country) {
            const callingCode = country?.countryCallingCode?.replace('+', '');
            const code = getCountryCodeFromCallingCode(callingCode);
            setCountryCode(code?.toLowerCase());
          }
        }
      } else {
        setBranchDetails({
          ...branchDetails,
          country: '',
          currency: '',
        });
        setValidStateCountry(false);
      }
    },
    [branchDetails]
  );

  // Handle submit
  const handleSubmit = async (event: any) => {
    event.preventDefault();

    try {
      let formIsValid = true;
      if (!branchDetails.branchName) {
        setValidStateBranchName(false);
        formIsValid = false;
      }
      if (!branchDetails.buildingNumber) {
        setValidStateBuildingNumber(false);
        formIsValid = false;
      }
      if (!branchDetails.locality) {
        setValidStateLocality(false);
        formIsValid = false;
      }
      if (!branchDetails.email) {
        setValidStateEmail(false);
        formIsValid = false;
      }
      if (!branchDetails.contactNumber) {
        setValidStatePhone(false);
        formIsValid = false;
      }
      if (!branchDetails.country) {
        setValidStateCountry(false);
        formIsValid = false;
      }

      if (
        formIsValid &&
        validStateEmail &&
        validStatePhone &&
        validStateBranchName &&
        validStateBuildingNumber &&
        validStateLocality &&
        validStateCountry
      ) {
        add
          ? CreateBranch({
              ...branchDetails,
              isFirstBranch:
                validatingFirstTimeBranchCreation?.branchCreated === true
                  ? false
                  : true,
              instituteId: activeInstitute?.id,
              createdByName: authUser?.firstName + ' ' + authUser?.lastName,
              createdById: authUser?.institute[0]?.id,
            })
          : UpdateBranch({
              ...branchDetails,
              isFirstBranch: false,
              instituteId: branchById?.instituteId,
              createdByName: branchById?.createdByName,
              createdById: branchById?.createdById,
              updatedById: authUser?.institute[0]?.id,
              updatedByName: authUser?.firstName + ' ' + authUser?.lastName,
            });
      }
    } catch (error) {}
  };

  const handleModalClose = () => setOpenModal(false);

  const noButtonClick = () => {
    setOpenModal(false);
  };

  const yesButtonClick = () => {
    reset();
    setOpenModal(false);
    const pathname = window.location.pathname;
    const branchId = pathname.substring(pathname.lastIndexOf('/') + 1);
    add
      ? navigate(`/app/manage/Branches`)
      : navigate(`/app/manage/Branches?selectedBranch=${branchDetails?.id}`, {
          state: { branchId: branchId, menuItemNumber: 1 },
        });
  };
  const { isFirstBranch, ...filteredBranchDetails } = branchDetails;
  const filteredOriginalBranchKeys = filterObjectKeys(
    branchById,
    filteredBranchDetails
  );
  const isObjectsEqual = checkObjectsEqual(
    filteredBranchDetails,
    filteredOriginalBranchKeys
  );

  const cancelButtonClick = () => {
    if (isObjectsEqual) {
      const pathname = window.location.pathname;
      const branchId = pathname.substring(pathname.lastIndexOf('/') + 1);
      add
        ? navigate(`/app/manage/Branches`)
        : navigate(`/app/manage/Branches`, {
            state: { branchId: branchId, menuItemNumber: 1 },
          });
    } else {
      setOpenModal(true);
    }
  };

  React.useEffect(() => {
    if (activeInstitute?.isProfileCompleted === false && activeInstitute?.id) {
      GetInstituteByIdRequest(activeInstitute?.id)
        ?.then((res: any) => {
          setValidatingFirstTimeBranchCreation(res?.data?.data);
        })
        .catch((err) => {});
    } else {
      setValidatingFirstTimeBranchCreation(activeInstitute);
    }
  }, []);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, []);

  React.useEffect(() => {
    if (!add) {
      const pathname = window.location.pathname;
      const branchId = pathname.substring(pathname.lastIndexOf('/') + 1);
      GetBranchById(branchId);
      setFormDisabled(true);
    }
  }, [add, GetBranchById, window.location]);

  React.useEffect(() => {
    if (!add && branchById) {
      setBranchDetails({
        ...branchById,
        contactNumber: `${branchById?.contactCountryCode || '91'}${
          branchById?.contactCountryCode
            ? branchById?.contactNumber.replace(
                branchById?.contactCountryCode,
                ''
              )
            : branchById?.contactNumber.startsWith('91')
            ? branchById?.contactNumber.replace('91', '')
            : branchById?.contactNumber
        }`,
      });
      setImage(branchById?.branchImage);
      setEditVal({
        position: {
          lat: parseFloat(branchById.latitude),
          lng: parseFloat(branchById.longitude),
        },
      });
    }
  }, [add, branchById, setBranchDetails]);

  useEffect(() => {
    setBranchDetails({
      ...branchDetails,
      isFirstBranch:
        validatingFirstTimeBranchCreation &&
        validatingFirstTimeBranchCreation?.branchCreated === true
          ? false
          : true,
    });
  }, [validatingFirstTimeBranchCreation]);

  useEffect(() => {
    if (success !== true && success !== false) {
      if (activeInstitute?.id) {
        getInstituteById(activeInstitute?.id);
      }
      if (window.location.pathname.includes('Billing')) {
        navigate('/app/manage/Billing/ManageSubscription');
      } else {
        if (branchDetails.isFirstBranch === true) {
          navigate('/app/manage/Courses');
          dispatch<any>(getUserById(authUser?.institute?.[0]?.id));
        } else {
          if (!add) {
            navigate(
              `/app/manage/Branches?selectedBranch=${branchDetails?.id}`
            );
          } else {
            navigate(`/app/manage/Branches`);
          }
        }
      }
    }
  }, [success, navigate]);

  useEffect(() => {
    if (window.location.href.includes('CreateBranch')) {
      setIsActive(1);
    }
  }, [setIsActive, add, setFormDisabled]);

  useEffect(() => {
    const element = document.getElementById('branches');
    if (element) {
      element.scrollIntoView({ behavior: 'auto' });
    }
  }, []);
  const [logoDetails, setLogoDetails] = React.useState<any>({
    fileBase64String: '',
    fileName: '',
    fileType: 'BRANCH_IMAGE',
    instituteId: '',
    branchId: '',
  });

  const [image, setImage] = React.useState<any>(galleryIcon);

  const handleImageSubmit = React.useCallback(
    (fileName: any, convertedFile: any) => {
      const pathname = window.location.pathname;
      const branchId = pathname.substring(pathname.lastIndexOf('/') + 1);
      let logo_Detail = {
        fileBase64String: convertedFile,
        fileName: fileName,
        fileType: 'BRANCH_IMAGE',
        instituteId: activeInstitute?.id,
        branchId: branchId,
      };
      setLogoDetails(logo_Detail);
      try {
        logo_Detail.fileBase64String !== '' &&
          dispatch<any>(fileUpload(logo_Detail));
      } catch (error) {}
    },
    []
  );

  const handleLogoUpload = React.useCallback(
    async (imageUrl: any, fileName: any) => {
      if (imageUrl) {
        setLogoDetails({
          ...logoDetails,
          fileBase64String: imageUrl,
        });
        handleImageSubmit(fileName, imageUrl);
      }
    },
    [logoDetails]
  );

  const handleImageUpload = React.useCallback(
    async (cropImage: any, image: any) => {
      handleLogoUpload(cropImage, image.name);
    },
    []
  );

  const { fileUploadSuccess, imageUrl } = useSelector(
    (state: any) => state.fileUpload
  );

  React.useEffect(() => {
    if (fileUploadSuccess) {
      setBranchDetails({
        ...branchDetails,
        branchImage: `${imageUrl?.location}?timestamp=${Date.now()}`,
      });
    }
  }, [fileUploadSuccess]);

  return (
    <>
      <Container
        sx={{
          overflowY: 'auto',
          maxHeight: '100%',
        }}
      >
        <Box sx={{ paddingTop: '22px' }}>
          {backBtn ? (
            <button className={styles.PageBackBtn} onClick={() => navigate(-1)}>
              <ArrowBackIcon
                sx={{
                  marginRight: '8px',
                  fontSize: '15PX',
                  color: '#667085',
                }}
              />
              Back
            </button>
          ) : (
            <></>
          )}
          {!add && branchByIdLoading ? (
            <BranchSkeleton />
          ) : (
            <div>
              <div
                style={{
                  borderBottom: '1px solid #EDEDED',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
                id="branches"
              >
                <p
                  style={{
                    color: '#142C44',
                    fontSize: '18px',
                    fontFamily: 'Poppins',
                    fontWeight: '500',
                    margin: '10px 0px',
                  }}
                >
                  {add ? 'Add' : 'Edit'} Branch
                </p>
              </div>

              <Box className={styles.contacDetailsGrid}>
                <p
                  style={{
                    color: '#142C44',
                    fontFamily: 'Poppins',
                    fontWeight: '500',
                    fontSize: '14px',
                  }}
                >
                  Institute Location
                </p>

                <form
                  id="form"
                  //  onSubmit={handleSubmit}
                >
                  <Grid item xs={12}>
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        gap: '10%', // 10% gap between map and preview
                      }}
                    >
                      <Box sx={{ flex: '0 0 60%' }} className={styles.mapGrid}>
                        <MapAutocomplete
                          handleGeoChange={handleGeoChange}
                          latitude={
                            branchDetails.latitude !== null &&
                            branchDetails.latitude
                          }
                          longitude={
                            branchDetails.longitude !== null &&
                            branchDetails.longitude
                          }
                          add={add}
                          disabled={formDisabled}
                          placeholder="Name of the place"
                          editVal={editVal !== null && editVal}
                        />
                        <Box className={styles.googleMap}></Box>
                      </Box>

                      <Box sx={{ flex: '0 0 30%' }} className={styles.mapGrid}>
                        <Previews
                          setImage={setImage}
                          handleImageUpload={handleImageUpload}
                          imgUrl={image}
                        />
                      </Box>
                    </Box>
                  </Grid>

                  <Box sx={{ my: 4 }}>
                    <Grid
                      container
                      spacing={{ lg: 3, md: 3, xs: 1, sm: 1 }}
                      columns={{ xs: 4, sm: 8, md: 12 }}
                    >
                      <Grid item xs={6}>
                        <NewFormTextInput
                          validate={true}
                          setValidStatus={setValidateStatusBranchName}
                          label="Branch Name"
                          type="text"
                          id={'branchName'}
                          error={
                            !validStateBranchName ||
                            branchDetails.branchName.length > 50
                          }
                          value={branchDetails.branchName}
                          onChange={handleChange}
                          showErrorMessage={showErrMsz}
                          errorType={errorType}
                          autoComplete="true"
                          require={true}
                          inputProps={{ maxLength: 50 }}
                        />
                      </Grid>

                      <Grid item xs={6}>
                        <NewFormTextInput
                          validate={true}
                          setValidStatus={setValidateStatusBuildingNumber}
                          label="Building No / Block No"
                          type="text"
                          id={'buildingNumber'}
                          error={!validStateBuildingNumber}
                          value={branchDetails.buildingNumber}
                          onChange={handleChange}
                          showErrorMessage={showErrMsz}
                          errorType={errorType}
                          autoComplete="true"
                          require={true}
                          inputProps={{ maxLength: 50 }}
                        />
                      </Grid>

                      <Grid item xs={6}>
                        <NewFormTextInput
                          validate={true}
                          setValidStatus={setValidateStatusLocality}
                          label="Locality"
                          type="text"
                          id={'locality'}
                          error={!validStateLocality}
                          value={branchDetails.locality}
                          onChange={handleChange}
                          showErrorMessage={showErrMsz}
                          errorType={errorType}
                          autoComplete="true"
                          require={true}
                          inputProps={{ maxLength: 50 }}
                        />
                      </Grid>

                      <Grid item xs={6}>
                        <InputLabel
                          sx={{
                            fontSize: '12px',
                            color: '#142C44',
                            fontWeight: '500',
                            marginBottom: '5px',
                            fontFamily: 'Poppins',
                            display: 'flex',
                          }}
                        >
                          Pin
                        </InputLabel>
                        <TextField
                          id={'pin'}
                          variant="outlined"
                          fullWidth
                          value={branchDetails.pin}
                          inputProps={{
                            maxLength: 6,
                          }}
                          error={pinError}
                          helperText={pinError ? 'Invalid PIN code' : ''}
                          onChange={handlePinChange}
                          size="small"
                        />
                      </Grid>

                      <Grid item xs={6}>
                        <NewFormTextInput
                          onChange={handleChange}
                          id={'city'}
                          label="City"
                          variant="standard"
                          fullWidth
                          value={branchDetails.city}
                          inputProps={{ maxLength: 50 }}
                        />
                      </Grid>

                      <Grid item xs={6}>
                        <NewFormTextInput
                          onChange={handleChange}
                          id={'state'}
                          label="State"
                          variant="standard"
                          fullWidth
                          value={branchDetails.state}
                          inputProps={{ maxLength: 50 }}
                        />
                      </Grid>

                      <Grid item xs={6}>
                        <NewFormTextInput
                          onChange={handleChange}
                          id={'landmark'}
                          label="Landmark"
                          fullWidth
                          value={branchDetails.landmark}
                          maxRows={1}
                          inputProps={{
                            maxLength: 50,
                          }}
                        />
                      </Grid>

                      <Grid item xs={6}>
                        <AutoCompleteField
                          id="country"
                          label="Country"
                          options={countries}
                          optionLabel={'name'}
                          onChange={onCountryChange}
                          value={selectedCountry}
                          disableClearable={
                            branchDetails?.country === '' ? true : false
                          }
                          required={true}
                          validState={validStateCountry}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <NewFormTextInput
                          validate={true}
                          setValidStatus={setValidateStatusEmail}
                          label="Email Address"
                          type="email"
                          id={'email'}
                          error={!validStateEmail}
                          value={branchDetails.email}
                          onChange={handleChange}
                          showErrorMessage={showErrMsz}
                          errorType={errorType}
                          autoComplete="true"
                          require={true}
                          inputProps={{ maxLength: 50 }}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <InputLabel
                          sx={{
                            fontSize: '12px',
                            color: '#142C44',
                            fontWeight: '500',
                            marginBottom: '5px',
                            fontFamily: 'Poppins',
                            display: 'flex',
                          }}
                        >
                          Phone Number
                          <p style={{ margin: '0px 4px', color: '#D32F2F' }}>
                            *
                          </p>
                        </InputLabel>
                        <CountryCodePhoneInput
                          value={branchDetails.contactNumber}
                          country={countryCode}
                          onChange={(event: any, country: any) => {
                            if (event !== '') {
                              setValidStatePhone(
                                isValidPhoneNumber(
                                  event.replace(country.dialCode, ''),
                                  country.countryCode.toUpperCase()
                                )
                              );
                            }

                            setBranchDetails({
                              ...branchDetails,
                              contactNumber: event,
                              contactCountryCode: country.dialCode,
                            });
                          }}
                          error={validStatePhone}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <InputLabel
                          sx={{
                            fontSize: '12px',
                            color: '#142C44',
                            fontWeight: '500',
                            marginBottom: '5px',
                            fontFamily: 'Poppins',
                            display: 'flex',
                          }}
                        >
                          Currency
                          {/* <p style={{ margin: "0px 4px", color: "#D32F2F" }}>
                            *
                          </p> */}
                        </InputLabel>
                        <div
                          style={{
                            display: 'flex',
                            border: '1px solid #c4c4c4',
                            borderRadius: '6px',
                            padding: '0px 14px',
                            height: '40px',
                            alignItems: 'center',
                            fontFamily: 'Roboto',
                          }}
                        >
                          {branchDetails?.currency && (
                            <>
                              <img
                                src={
                                  getCountryByName(branchDetails?.country)
                                    ?.flags?.png
                                }
                                width="20px"
                                height="15px"
                                style={{ marginRight: '12px' }}
                              />
                              {branchDetails?.currency}
                            </>
                          )}
                        </div>
                        {/* <CurrencyDropDown
                          initialCurrency={
                            branchDetails?.currency
                              ? branchDetails?.currency
                              : ""
                          }
                          handleUpdateCurrency={handleUpdateCurrency}
                          // disabled={true}
                        /> */}
                      </Grid>
                    </Grid>
                    <Box sx={{ mb: '50px' }}>
                      <Box
                        sx={{
                          marginBottom: '30px',
                          marginTop: '30px',
                          gap: '10px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'flex-end',
                        }}
                      >
                        {validatingFirstTimeBranchCreation?.isProfileCompleted && (
                          <CancelBtn onClick={() => cancelButtonClick()} />
                        )}
                        <SaveBtn
                          onClick={handleSubmit}
                          disabled={loading}
                          loader={loading}
                        />
                      </Box>
                    </Box>
                  </Box>
                </form>
              </Box>
            </div>
          )}

          {openModal && (
            <CancelModal
              open={openModal}
              onClose={handleModalClose}
              noButtonClick={noButtonClick}
              yesButtonClick={yesButtonClick}
            />
          )}
        </Box>
      </Container>
    </>
  );
}
